import { render, staticRenderFns } from "./GetPremiumForm.vue?vue&type=template&id=4f19392a&"
import script from "./GetPremiumForm.vue?vue&type=script&lang=js&"
export * from "./GetPremiumForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports